export default __webpack_public_path__ + "static/Image_5-2bff1ad4abcd40d816f56ee83e514d85.jpg";